// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorDiv{font-size:13px;font-weight:400}`, "",{"version":3,"sources":["webpack://./src/components/account/unauthorizedIPError/style.scss"],"names":[],"mappings":"AAEA,UACI,cAAA,CACA,eAAA","sourcesContent":["@import '../../../styles/_globals.scss';\n\n.errorDiv {\n    font-size: 13px;\n    font-weight: 400;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorDiv": `errorDiv`
};
export default ___CSS_LOADER_EXPORT___;
